export enum Operation {
  Create,
  Update,
  Delete
}